import * as React from "react";

import { JoinDrawer } from "../../Common";

import {
  NotifyMeUserExperience_Step,
  usePdpNotifyMeUserExperience,
  usePdpWishlistUserExperience,
  useReactPdpInitialState,
  WishlistUserExperience_Step,
} from "../providers";

import {
  useNotifyMeDrawerFragment,
  useWishlistDrawerFragment,
  WishlistDrawerFragment,
} from "./wishlist-drawer-fragment";

export const PdpDrawer: React.FunctionComponent = () => {
  const {
    presentingUserExperienceStep:
      pdpWishlistUserExperience_presentingUserExperienceStep,
    handleCloseOfTheRightDrawerAtAnyTime:
      pdpWishlistUserExperience_handleCloseOfTheRightDrawerAtAnyTime,
  } = usePdpWishlistUserExperience();
  const {
    presentingUserExperienceStep:
      pdpNotifyMeUserExperience_presentingUserExperienceStep,
    handleCloseOfTheRightDrawerAtAnyTime:
      pdpNotifyMeUserExperience_handleCloseOfTheRightDrawerAtAnyTime,
  } = usePdpNotifyMeUserExperience();

  const {
    classNameForTheDrawer: pdpWishlistUserExperience_classNameForTheDrawer,
  } = useWishlistDrawerFragment(
    pdpWishlistUserExperience_presentingUserExperienceStep
  );
  const {
    classNameForTheDrawer: pdpNotifyMeUserExperience_classNameForTheDrawer,
  } = useNotifyMeDrawerFragment(
    pdpNotifyMeUserExperience_presentingUserExperienceStep
  );

  const handleClose = React.useCallback(() => {
    pdpWishlistUserExperience_handleCloseOfTheRightDrawerAtAnyTime();
    pdpNotifyMeUserExperience_handleCloseOfTheRightDrawerAtAnyTime();
  }, [
    pdpWishlistUserExperience_handleCloseOfTheRightDrawerAtAnyTime,
    pdpNotifyMeUserExperience_handleCloseOfTheRightDrawerAtAnyTime,
  ]);

  const present = React.useMemo(() => {
    const wishlistIsPresenting =
      pdpWishlistUserExperience_presentingUserExperienceStep !==
        WishlistUserExperience_Step.NOT_PRESENTING &&
      pdpWishlistUserExperience_presentingUserExperienceStep !==
        WishlistUserExperience_Step.CLOSING;
    const notifyMeIsPresenting =
      pdpNotifyMeUserExperience_presentingUserExperienceStep !==
        NotifyMeUserExperience_Step.NOT_PRESENTING &&
      pdpNotifyMeUserExperience_presentingUserExperienceStep !==
        NotifyMeUserExperience_Step.CLOSING;
    return wishlistIsPresenting || notifyMeIsPresenting;
  }, [
    pdpWishlistUserExperience_presentingUserExperienceStep,
    pdpNotifyMeUserExperience_presentingUserExperienceStep,
  ]);

  const drawerClassName = React.useMemo(() => {
    return `${pdpWishlistUserExperience_classNameForTheDrawer} ${pdpNotifyMeUserExperience_classNameForTheDrawer}`;
  }, [
    pdpWishlistUserExperience_classNameForTheDrawer,
    pdpNotifyMeUserExperience_classNameForTheDrawer,
  ]);

  return (
    <JoinDrawer
      useInitialState={useReactPdpInitialState}
      present={present}
      drawerClassName={drawerClassName}
      handleClose={handleClose}
      allowJoining
    >
      <DrawerComposition />
    </JoinDrawer>
  );
};

const DrawerComposition: React.FunctionComponent = () => {
  return (
    <React.Fragment>
      <WishlistDrawerFragment />
    </React.Fragment>
  );
};
